import { useEffect, useState } from 'react';
import { downloadNewsCoverPhoto, NewsInfo } from '../../misc/lib/news';
import './NewsList.scss';

const NewsCardSidebar = (props: NewsInfo) => {
  const [ coverUrl, setCoverUrl ] = useState<string>();

  useEffect(() => {
    downloadNewsCoverPhoto(props.id, props.coverPath).then((file) => {
      setCoverUrl(URL.createObjectURL(file));
    }).catch((err) => {
      console.error(err);
    });
  }, [ props ]);

  return (
    <div className="app-news-card-sidebar">
      <img src={ coverUrl } alt="" />
      <h3>{ props.title }</h3>
      <p>{ props.body.replaceAll('#', '') }</p>
    </div>
  );
};

export default NewsCardSidebar;
